import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AppConfigSettings } from '@arc/arc-shared-frontend';
import { of } from 'rxjs';

export const hostedPaymentsPageCheckoutResolver: ResolveFn<object> = () => {
  const appSettings = inject(AppConfigSettings);
  appSettings.setconfig('useHostedPaymentsPageEndpoints', 'true');
  appSettings.setconfig('usePaymentLinkEndpoints', 'false');
  appSettings.setconfig('disableSavePaymentAccount', 'true');
  appSettings.setconfig('disablePaymentDate', 'true');
  appSettings.setconfig('navigateOnStepChange', 'true');
  return of({});
};
